import type {LngLat, LngLatBounds, MapLocationRequest} from '@yandex-delivery/blocks'

const ANIMATION_DURATION = 500

export function toCenterLocation(center: LngLat, zoom: number): MapLocationRequest {
  return {center, zoom, duration: ANIMATION_DURATION}
}

export function toBoundsLocation(bounds: LngLatBounds): MapLocationRequest {
  return {bounds, duration: ANIMATION_DURATION}
}
